import {RootState} from '../../types/redux';

export const getHasNavigation = (state: RootState) => {
  return state.global.availableNavigation;
};
